import axios from "axios";
export default {
  namespaced: true,
  state: {
    articulo: {},
    articulos: [],
  },
  mutations: {
    llenarArticulo(state, articuloAccion) {
      state.articulo = articuloAccion;
    },
    llenarArticulos(state, data) {
      state.articulos = data;
    },
  },
  actions: {
    getArticulos: async function({ commit }, dataArticulo) {
      let token = dataArticulo.token;
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;

      await axios
        .get(`articulo/list?valor=${dataArticulo.texto}`, configuracion)
        .then(function(response) {
          data = response.data;
          commit("llenarArticulos", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    updateCliente: async function({ commit }, dataArticulo) {
      let header = { Token: dataArticulo.token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .put(
          "persona/update",
          {
            _id: dataArticulo.id,
            tipo_persona: dataArticulo.tipo_persona,
            nombre: dataArticulo.nombre,
            tipo_documento: dataArticulo.tipo_documento,
            num_documento: dataArticulo.num_documento,
            direccion: dataArticulo.direccion,
            telefono: dataArticulo.telefono,
            email: dataArticulo.email,
          },
          configuracion
        )
        .then(function(res) {
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} ${res.data.apellido} fue actualizado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    updateDeuda: async function({ commit }, dataArticulo) {
      let header = { Token: dataArticulo.token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .put(
          "persona/updateDeuda",
          {
            _id: dataArticulo.id,
            deuda: dataArticulo.deuda,
          },
          configuracion
        )
        .then(function(res) {
          swal({
            title: "Buen trabajo!",
            text: `La deuda de ${res.data.nombre} ${res.data.apellido} fue actualizada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveCliente: async function({ commit }, dataArticulo) {
      let header = { Token: dataArticulo.token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .post(
          "persona/add",
          {
            tipo_persona: dataArticulo.tipo_persona,
            nombre: dataArticulo.nombre,
            tipo_documento: dataArticulo.tipo_documento,
            num_documento: dataArticulo.num_documento,
            direccion: dataArticulo.direccion,
            telefono: dataArticulo.telefono,
            email: dataArticulo.email,
          },
          configuracion
        )
        .then(function(res) {
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} ${res.data.apellido} fue agregado exitosamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    activateCliente: async function({ commit }, dataArticulo) {
      let header = { Token: dataArticulo.token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .put("persona/activate", { _id: dataArticulo.id }, configuracion)
        .then(function(res) {
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} ${res.data.apellido} fue activado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    deactivateCliente: async function({ commit }, dataArticulo) {
      let header = { Token: dataArticulo.token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .put("persona/deactivate", { _id: dataArticulo.id }, configuracion)
        .then(function(res) {
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} ${res.data.apellido} fue desactivado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    deleteCliente: async function({ commit }, dataArticulo) {
      let token = dataArticulo.token;
      let header = { Token: token };
      let configuracion = { headers: header };

      await axios
        .delete(`persona/remove?_id=${dataArticulo.id}`, configuracion)
        .then(function(res) {
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} ${res.data.apellido} fue eliminado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
